import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface AccordionItem {
  title: string;
  content: string;
  cta?: string;
  ctaHref?: string;
}
interface UseCaseAccordionProps {
  items: AccordionItem[];
}
export const UseCaseAccordion: React.FC<UseCaseAccordionProps> = ({
  items
}) => {
  const [activeIndex, setActiveIndex] = useState(-1);
  const toggleAccordion = (index: number) => {
    setActiveIndex(activeIndex === index ? -1 : index);
  };
  return <div className="border-t border-lightgray" data-id="element-149">
      {items.map((item, index) => <div key={index} className="border-b border-lightgray" data-id="element-150">
          <button className="w-full text-left py-4 md:py-5 pr-4 flex justify-between items-start group" onClick={() => toggleAccordion(index)} data-id="element-151">
            <div className="flex-1" data-id="element-152">
              <h3 className="font-poppins font-normal text-lg md:text-xl text-black group-hover:text-lime transition-colors" data-id="element-153">
                {item.title}
              </h3>
            </div>
            <ChevronDownIcon className={`transform transition-all duration-300 flex-shrink-0 mt-1 text-black group-hover:text-lime ${activeIndex === index ? 'rotate-180' : 'rotate-0'}`} size={20} data-id="element-154" />
          </button>
          <div className={`overflow-hidden transition-all duration-300 ${activeIndex === index ? 'max-h-96 opacity-100 pb-4 md:pb-5' : 'max-h-0 opacity-0'}`} data-id="element-155">
            <p className="font-inter text-base leading-relaxed text-black mb-6" data-id="element-156">
              {item.content}
            </p>
            {item.cta && item.ctaHref && <a href={item.ctaHref} className="font-inter font-semibold inline-flex items-center text-black hover:text-lime transition-colors" data-id="element-157">
                {item.cta}
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="ml-1" data-id="element-158">
                  <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-159" />
                </svg>
              </a>}
          </div>
        </div>)}
    </div>;
};